import type { ReactNode } from 'react';

import { cn } from '@/ui/utils/classnames.js';
import FixedLayout from './parts/fixed-layout.js';
import ResponsiveLayout from './parts/responsive-layout.js';

export interface LayoutProps {
  children: ReactNode;
  header?: ReactNode;
  responsive?: boolean;
  className?: string;
  scrollContainerClassName?: string;
}

function Layout({
  children,
  header,
  responsive,
  className,
  scrollContainerClassName,
}: LayoutProps) {
  return responsive ? (
    <ResponsiveLayout
      header={header}
      className={cn(className, scrollContainerClassName)}
    >
      {children}
    </ResponsiveLayout>
  ) : (
    <FixedLayout
      header={header}
      className={className}
      scrollContainerClassName={scrollContainerClassName}
    >
      {children}
    </FixedLayout>
  );
}

export default Layout;
